export function initReloadOnPreloadError() {
	window.addEventListener("vite:preloadError", (event) => {
		const lastReloadAt = Number(sessionStorage.getItem(lastReloadAtKey) ?? "0");
		if (Date.now() - lastReloadAt < reloadCooldownMs) return;
		sessionStorage.setItem(lastReloadAtKey, String(Date.now()));
		event.preventDefault();
		window.location.reload();
	});
}

const lastReloadAtKey = "preload-error-reload-at";
const reloadCooldownMs = 30_000;
